import type { WebsocketOptions, WebsocketStore } from './type';

import { useCreateWebsocket } from './hooks/useCreateWebsocket';
import { createContext, useContext } from 'react';
import { WSContextType } from './type';

export const WebsocketContext = createContext<Record<WSContextType, WebsocketStore> | undefined>(
  undefined,
);

type WebsocketProviderProps = {
  options: WebsocketOptions;
  children: React.ReactNode;
};

export const WebsocketProvider: React.FC<WebsocketProviderProps> = ({ options, children }) => {
  const websocketGemXStore = useCreateWebsocket(options);

  return (
    <WebsocketContext.Provider value={{ [WSContextType.GEMX]: websocketGemXStore }}>
      {children}
    </WebsocketContext.Provider>
  );
};

export const useWebsocketContext = (props?: { type?: WSContextType }): WebsocketStore => {
  const type = props?.type ?? WSContextType.GEMX;
  const websocketStore = useContext(WebsocketContext);

  if (!websocketStore) {
    throw new Error('useWebsocketContext must be used within a WebsocketProvider');
  }

  return websocketStore[type];
};
